// @flow
import * as React from 'react';
import Theme from '../../themes';
import Button from '../../common/forms/Button';
import Icon from '../../components/shared/Icons/Icon';
import styles from './styles';

const iconStyles = {
  fill: 'white',
  color: 'white',
  padding: '0.32em',
  borderRadius: '6px',
  backgroundColor: null,
};

const buttonCTAStyles = {
  fontSize: '14px',
  fontWeight: 'bold',
  lineHeight: '1.2',
  borderRadius: '25px',
  padding: '12px 16px',
};

type Props = {
  downloadAppUrl: string,
  verticalName: VerticalName,
  downloadAppTitle: string | Object,
  downloadAppSlogan: string | Object,
  downloadAppCTA: string | Object,
  handleClose: Function,
};

function DownloadAppTopBanner({
  downloadAppUrl,
  verticalName,
  downloadAppTitle,
  downloadAppSlogan,
  downloadAppCTA,
  handleClose,
}: Props): React.Node {
  iconStyles.backgroundColor = Theme[verticalName].main;

  return (
    <div className="download_app_banner" data-test="download-app-banner">
      <div className="close download_app_banner__block" onClick={handleClose}>
        <Icon type="close" width={24} height={24} />
      </div>
      <div className="icon download_app_banner__block">
        <a href={downloadAppUrl} onClick={handleClose}>
          <Icon type={verticalName} width={42} height={42} style={iconStyles} />
        </a>
      </div>
      <div className="text download_app_banner__block">
        <a href={downloadAppUrl} onClick={handleClose}>
          <p className="title download_app_banner__text-line">{downloadAppTitle}</p>
          <p className="slogan download_app_banner__text-line">{downloadAppSlogan}</p>
        </a>
      </div>
      <div className="link download_app_banner__block">
        <a href={downloadAppUrl} onClick={handleClose}>
          <Button title={downloadAppCTA} size="medium" color="blue" style={buttonCTAStyles} />
        </a>
      </div>
      <style jsx>{styles}</style>
    </div>
  );
}

export default DownloadAppTopBanner;



// WEBPACK FOOTER //
// ./app/DownloadAppBanner/TopBanner/index.js